import queryString from "query-string";

export type ParseOptions = queryString.ParseOptions;

export const getQueryParams = (data: string, options: queryString.ParseOptions = {}): queryString.ParsedQuery<string> => {
  return queryString.parse(data, options);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const convertJsonToQueryString = (data: Record<string, any>, options: queryString.StringifyOptions = {}): string => {
  return queryString.stringify(data, {
    skipNull: true,
    skipEmptyString: true,
    ...options,
  });
};

export const convertQueryStringToJson = (data: string, options: queryString.ParseOptions = {}): queryString.ParsedQuery<string> => {
  return queryString.parse(data, {
    ...options,
    /* Not supported on parse (apparently)
     skipNull: true, */
  });
};
